module.exports.default = {
    "ORDER": "Pedido",
    "SCHEDULE.YOU_ARE_ALL_SET": "",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "A túa entrega está axendada para",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Ola #, por favor axenda a túa entrega",
    "SCHEDULE.SCHEDULE_NOW": "Reprogramar",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Entrega y Actualización de Estados",
    "SCHEDULE.EMAIL_UPDATES": "Actualizacións por correo electrónico",
    "SCHEDULE.SMS_UPDATES": "Actualizacións por SMS",
    "SCHEDULE.DISABLE_UPDATES": "Non quero recibir actualizacións",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Gustaríame recibir información actualizada sobre a miña entrega nas seguintes canles:",
    "OOPS": "Sentímolo!",
    "SOMETHING_WENT_WRONG": "Algo saíu mal",
    "REFRESH": "Refrescar",
    "PAGE_NOT_FOUND": "Páxina non encontrada",
    "COULD_NOT_FIND_PAGE": "Non puidemos encontrar a páxina que buscas.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Non pode enviar unha mensaxe baleira",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Por favor, ingresa a túa mensaxe ao repartidor",
    "TRACKING.SEND": "Enviar",
    "TRACKING.ARRIVING_AT": "Chegando ás",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "minutos",
    "TRACKING.MAP": "Mapa",
    "TRACKING.SATELLITE": "Satélite",
    "TRACKING.TERRAIN": "Terreo",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Ola, cheguei!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": ", o teu repartidor, chegou a ",
    "COMPLETED": "Completado",
    "RATING.SKIP": "Agora non",
    "RATING.WHAT_WENT_WELL": "Que saíu ben?",
    "RATING.WHAT_WENT_WRONG": "Que saíu mal?",
    "RATING.THANK_YOU": "Grazas",
    "RATING.FOR_USING_OUR_SERVICE": "por usar o noso servizo!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Como foi a súa experiencia de entrega?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Grazas por usar o noso servizo",
    "SCHEDULE.RATE_US": "Valóranos",
    "TERM_OF_USE": "Condicións de Uso",
    "PRIVACY_POLICY": "Política de privacidade",
    "SHARING_MY_LOCATION": "Compartindo a miña situación",
    "SHARING_LOADING": "Cargando",
    "REQUIRED_FIELD_MESSAGE": "O campo é requirido",
    "CONTACT_NAME": "Nome de contacto",
    "PHONE_NUMBER": "Número de teléfono",
    "EMAIL_ADDRESS": "Enderezo de correo electrónico",
    "SEND": "Enviar",
    "FORWARD.THIS_ORDER": "Enviar este pedido",
    "FORWARD.TO_CONTACT": "Envía para contactar",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Está seguro de que quere enviar este pedido?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "envioulle un pedido",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Está seguro de que quere rexeitar este pedido?",
    "ACCEPT": "Aceptar",
    "REJECT": "Rexeitar",
    "PICKUP.SET_PICKUP_TIME": "",
    "PICKUP.IVE_ARRIVED": "",
    "PICKUP.PICKUP_ETA_SET_FAILED": "",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "",
    "PICKUP.MIN": "minutos",
    "PICKUP.SHOW_THIS_NUMBER": "",
    "PICKUP.IM_OUTSIDE": "",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "",
    "PICKUP.I_WILL_ARRIVE_AT": "",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "",
    "PICKUP.IN": "",
    "PICKUP.TO": "",
    "PICKUP.COLLECT": "",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "",
    "PICKUP.CANCEL": "",
    "PICKUP.CONFIRM_TIME": "",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "",
    "PICKUP.OK": "",
    "PICKUP.NEXT": "",
    "PICKUP.SKIP": "Saltar",
    "CAR_ARRIVED.TITLE": "",
    "CAR_ARRIVED.PARKING_SPOT": "",
    "CAR_ARRIVED.LICENSE_PLATE": "",
    "CAR_ARRIVED.VEHICLE_MODEL": "",
    "CAR_ARRIVED.VEHICLE_COLOR": "",
    "CAR_ARRIVED.REMEMBER": "",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "",
    "REDIRECT_PICKUP.TO": "",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "",
    "REDIRECT_PICKUP.FAILED_TITLE": "",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "",
    "REDIRECT_PICKUP.OK": "",
    "REDIRECT_PICKUP.KM": "",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "",
    "SOON": "",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "",
    "GLOBAL.CALL": "",
    "GLOBAL.CANCEL": "",
    "﻿PICKUP.SET_PICKUP_TIME": "",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "",
    "SCHEDULED.THANKS_FOR_USING": "",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "A túa entrega está axendada para",
    "Submit": "",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Para poder valorar, selecciona as estrellas primeiro",
    "PICKUP.SHOW_ID": "",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "",
    "OPEN_MENU": "",
    "CLOSE_MENU": "",
    "MAP_AUTO_CENTER": "",
    "MAP_SETTINGS": "",
    "ZOOM_OUT": "",
    "ZOOM_IN": "",
    "TRACKING.CALL_DRIVER": "",
    "TRACKING.MESSAGE_DRIVER": "",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "",
    "SCHEDULE.TIME_ZONE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "",
    "TRACKING.THANKS_MESSAGE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_TITLE": "",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "",
    "CANCEL_ORDER": "",
    "CANCELLATION_VALIDATION_TITLE": "",
    "CANCELLATION_VALIDATION_BACK": "",
    "CANCELLATION_VALIDATION_YES": "",
    "CANCEL_SUCCESS": "",
    "CANCEL_PAST_ALLOWED": "",
    "CANCEL_ERROR": "",
    "RATING.FREE_TEXT_COMMENT": "",
    "RATING.ORDER_DELIVERED_GREEN": "",
    "CX_ORDER_STATUS.CONFIRMED": "",
    "CX_ORDER_STATUS.RECEIVED": "",
    "CX_ORDER_STATUS.FINDING_DRIVER": "",
    "CX_ORDER_STATUS.DRIVER_FOUND": "",
    "CX_ORDER_STATUS.PICKING_UP": "",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "",
    "CX_ORDER_STATUS.ARRIVED": "",
    "TRACKING.DELIVERY_STATUS_TITLE": "",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "",
    "CONFIRM": "",
    "FLOW_OPTIONS.TITLE": "",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "",
    "RATING_STAR_ALT": "",
    "RATING_STAR_ALT_ONE": "",
    "RATING_STAR_ALT_TWO": "",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "",
    "SCHEDULE.EXTERNAL_ID_INFO": "",
    "SCHEDULE.TASK_NOTE_LABEL": "",
    "SCHEDULE.CANCEL_NOTE_INPUT": "",
    "DELIVERY_WAS_CANCELLED": "",
    "QUESTIONNAIRE.SKIP": "",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "",
    "QUESTIONNAIRE.BACK": "",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": "",
    "QUESTIONNAIRE.PROGRESS_BAR_TITLE": "",
    "QUESTIONNAIRE.NEXT": "",
    "QUESTIONNAIRE.INVALID_FORMAT": "",
    "RESCHEDULE.NEED_A_DIFFERENT_TIME": "",
    "RESCHEDULE.RESCHEDULE_YOUR_DELIVERY": "",
    "RESCHEDULE.GREETING": "",
    "RESCHEDULE.FIRST_AVAILABLE": "",
    "RESCHEDULE.SAME_DAY": "",
    "RESCHEDULE.PICK_A_DATE": "",
    "RESCHEDULE.NEAREST_WINDOWS": "",
    "RESCHEDULE.WINDOWS_FOR_DATE": "",
    "RESCHEDULE.WHICH_DATE": "",
    "RESCHEDULE.NO_WINDOWS": "",
    "RESCHEDULE.NO_WINDOWS_AVAILABLE": "",
    "RESCHEDULE.SOMETHING_WENT_WRONG": "",
    "RESCHEDULE.TRY_AGAIN": "",
    "RESCHEDULE.BACK_TO_START": "",
    "RESCHEDULE.BACK_TO_DELIVERY": "",
    "RESCHEDULE.CONFIRMED": "",
    "RESCHEDULE.TYPE_A_MESSAGE": "",
    "RESCHEDULE.TODAY": ""
};
	